import { useCallback, useEffect, useState } from "react";
import { GetAllNews, NewsTask } from "../firebase-config";

let newsCache: NewsTask[] | null = null;
let pendingNewsRequest: Promise<NewsTask[]> | null = null;

const loadNewsRecords = async (forceRefresh = false): Promise<NewsTask[]> => {
  if (!forceRefresh && newsCache) {
    return newsCache;
  }

  if (!forceRefresh && pendingNewsRequest) {
    return pendingNewsRequest;
  }

  pendingNewsRequest = GetAllNews()
    .then((newsRecords) => {
      newsCache = newsRecords;
      pendingNewsRequest = null;
      return newsRecords;
    })
    .catch((error) => {
      pendingNewsRequest = null;
      throw error;
    });

  return pendingNewsRequest;
};

export const invalidateNewsData = () => {
  newsCache = null;
  pendingNewsRequest = null;
};

const useNewsData = () => {
  const [newsData, setNewsData] = useState<NewsTask[]>(newsCache ?? []);
  const [isLoading, setIsLoading] = useState(false);

  const refreshNewsData = useCallback(async () => {
    setIsLoading(true);

    try {
      const newsRecords = await loadNewsRecords(true);
      setNewsData(newsRecords);
      return newsRecords;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (newsCache) {
      setNewsData(newsCache);
    }

    void refreshNewsData();
  }, [refreshNewsData]);

  return { newsData, isLoading, refreshNewsData };
};

export default useNewsData;